<template>
  <div>
    <div v-show="loading">
      <Loading />
    </div>
    <div v-if="errored">
      <ErrorPage />
    </div>
    <div v-else-if="notfound">
      <NotFound titulo="Informações da Fila de Espera" />
    </div>
    <div v-else class="food-page-section content-size section-home-noradius">
      <div class="wrap-food-recipe">
        <div class="heading-page-item">{{ textoTitulo }}</div>

        <div class="section-news-page">
          <div class="news-wrap">
            <div v-if="exibeImagem(caminhoImagem)">
              <Imagem :caminhoImagem="caminhoImagem"></Imagem>
              <br />
            </div>
            <p class="news-content">{{ textoDescricao }}</p>
            <h6>
              <a :href="`tel:` + textTelefone">{{ $t('CliqueAquiParaFazerSuaReserva') }}</a>
            </h6>
            <p>
              <a :href="`tel:` + textTelefone">{{ textTelefone }}</a>
            </p>
            <p></p>
            <!-- <h6>Tempo médio estimado</h6>
            <p>{{ textoTempoMedioEspera }}</p>-->
            <!-- <br />
            <h5>Colocar nome da fila</h5>
            <form>
              <div class="form-group">
                <label for="exampleInputEmail1">Nome completo</label>
                <input
                  type="text"
                  class="form-control"
                  id="nomecompleto"
                  placeholder="digite seu nome"
                />
              </div>
              <div class="form-group">
                <label for="exampleInputEmail1">E-mail</label>
                <input
                  type="email"
                  class="form-control"
                  id="nomecompleto"
                  placeholder="digite seu e-mail"
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Celular</label>
                <input
                  type="text"
                  class="form-control"
                  id="celular"
                  placeholder="digite seu celular"
                />
              </div>
              <button type="submit" class="btn btn-primary btn-sm">Enviar</button>
            </form>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorPage from "@/components/template/ErrorPage";
import NotFound from "@/components/template/NotFound";
import Loading from "@/components/template/Loading";
import Imagem from "@/components/Imagem";

import FunctionsMixin from '@/utils/functionsMixin.js'
import modulePagina from '@/store/paginas/modulePagina.js';

export default {
  name: "Cardapios-FilaEspera",

  components: {
    ErrorPage,
    NotFound,
    Loading,
    Imagem
  },

  mixins: [FunctionsMixin],

  data() {
    return {
      loading: false,
      errored: false
    };
  },

  computed: {
    stateFilaEspera() {
      return this.$store.state.modulePaginas.filaEspera
    },
    notfound() {
      return this.stateFilaEspera ? false : true
    },
    caminhoImagem() {
      return this.stateFilaEspera ? this.stateFilaEspera.imagem : ''
    },
    textoTitulo() {
      return this.stateFilaEspera
        ? (this.stateFilaEspera.tituloIdioma ? this.stateFilaEspera.tituloIdioma[this.$i18n.locale] : this.stateFilaEspera.titulo)
        : ''
    },
    textoDescricao() {
      return this.stateFilaEspera
        ? (this.stateFilaEspera.descricaoIdioma ? this.stateFilaEspera.descricaoIdioma[this.$i18n.locale] : this.stateFilaEspera.descricao)
        : ''
    },
    textoTempoMedioEspera() {
      return this.stateFilaEspera ? this.stateFilaEspera.tempoMedioEspera : ''
    },
    textTelefone() {
      return this.$store.state.dadosEstabelecimento === null
        ? ''
        : this.$store.state.dadosEstabelecimento.telefone;
    }
  },

  created() {
    if (!modulePagina.isRegistered) {
      this.$store.registerModule('modulePaginas', modulePagina)
      modulePagina.isRegistered = true
    }

    if (!this.stateFilaEspera) {
      const data = {
        estabelecimentoId: this.$store.state.dadosEstabelecimento.estabelecimentoId,
        tipoPagina: 'filaespera'
      }
      this.$store.dispatch('modulePaginas/fetchPaginaFilaEspera', data)
    }
  }
};
</script>

<style>
.submit-btn {
  padding-top: 15px;
}

.space {
  padding-left: 8px;
}
</style>
